import React from 'react';
import styled from 'styled-components';
import trees from '../../Assets/TreePlanting/treesFooter.png';
import { mobileMediaQuery, tabletMediaQuery, themeColor } from '../../Theming';
import { useTranslation } from 'react-i18next';

const Container = styled.footer`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  height: 482px;
  margin-top: 72px;
  border-radius: 14px;
  overflow: hidden;

  ${mobileMediaQuery} {
    flex-direction: column;
    height: auto;
    border-radius: 7px;
    margin-top: 40px;
  }
`;

const Image = styled.img`
  width: 50%;
  height: 100%;
  object-fit: cover;

  ${tabletMediaQuery} {
    width: 50%;
    height: auto;
  }

  ${mobileMediaQuery} {
    width: 100%;
    object-fit: contain;
  }
`;

const TextContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${themeColor('darkBackground')};
  padding: 50px 64px 50px 42px;

  ${tabletMediaQuery} {
    padding: 20px 29px 24px 24px;
  }
`;

const HeaderText = styled.h2`
  margin: 0 0 20px 0;
  font-family: SuisseIntl-Medium;
  font-weight: normal;
  color: ${themeColor('white')};
  font-size: 32px;

  ${tabletMediaQuery} {
    font-size: 23px;
    margin-bottom: 10px;
  }

  ${mobileMediaQuery} {
    font-size: 20px;
  }
`;

const Description = styled.p`
  font-family: SuisseIntl-Regular;
  color: ${themeColor('white')};
  font-size: 16px;

  ${tabletMediaQuery} {
    font-size: 15px;
  }

  ${mobileMediaQuery} {
    font-size: 14px;
  }
`;

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Image src={trees} alt="Tree plantation" />
      <TextContainer>
        <HeaderText>{t('treePlantingV2.footer.heading')}</HeaderText>
        <Description>
          {t('treePlantingV2.footer.descriptions.part1')}
        </Description>
        <Description>
          {t('treePlantingV2.footer.descriptions.part2')}
        </Description>
      </TextContainer>
    </Container>
  );
};

export default Footer;
